export default "__VITE_ASSET__MAN2kTsu__"